import { IVbUiDataGridValueFormatterParams } from './IVbUiDataGridValueFormatterParams';

export function notApplicableValueFormatter(params: IVbUiDataGridValueFormatterParams, showNotApplicable: boolean): string {
	return showNotApplicable ? params.context.getTranslation('NA') : params.value;
}
